<template>
  <v-tooltip
    :top="top"
    :bottom="bottom"
    :left="left"
    :right="right"
    :max-width="maxWidth"
    :z-index="zIndex"
  >
    <v-btn
      flat
      icon
      :color="color"
      slot="activator"
      class="help-tip"
    >
      <v-icon small class="help-tip__icon">help</v-icon>
    </v-btn>
    <slot></slot>
  </v-tooltip>
</template>

<script>
  export default {
    name: 'help-tip',
    props: {
      bottom: {
        type: Boolean,
        default: false
      },
      top: {
        type: Boolean,
        default: false
      },
      left: {
        type: Boolean,
        default: false
      },
      right: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: 'primary'
      },
      maxWidth: {
        type: [String, Number],
        default: 300
      },
      zIndex: {
        type: Number
      }
    }
  }
</script>

<style lang="stylus">
  .help-tip
    width: 18px
    height: 18px
    margin: 0
    padding: 0
</style>



// WEBPACK FOOTER //
// frontend/src/components/common/HelpTip.vue